import { createContext, useCallback, useContext } from 'react';

/**
 * Edits made through a picker count as unsaved input of the dialog or drawer around it
 * (`dirty="auto"`). A picker's list is portaled into its own layer, so no `input`/`change` event of
 * the choice reaches the dialog's DOM; the picker reports the edit through this context instead.
 */
export const EditReportContext = createContext<(() => void) | null>(null);

/** For value pickers (Select, Combobox …): call the returned function when the member changes the value. */
export function useReportEdit(): () => void {
  const report = useContext(EditReportContext);
  return useCallback(() => report?.(), [report]);
}
